import CustomDialog from "../utils/dialog/customDialog";
import { useScheduleTagging } from "./TaxAdjustment/hooks/useScheduleTagging";
import { getScheduleDocumentType } from "./TaxAdjustment/services/scheduleTaggingService";

const ChangeTaggingDialog = ({
  open,
  row,
  source,
  from,
  to,
  onClose,
  onDone,
  handleError,
}) => {
  const { unTagSchedule } = useScheduleTagging();
  return (
    <CustomDialog
      type='warning'
      open={open}
      onClose={() => onClose()}
      onConfirm={async () => {
        try {
          await unTagSchedule(
            source,
            row.row_id,
            getScheduleDocumentType(row.schedule.scheduleType)
          );

          const updatedRow = { ...row, taxAdjustment: to };
          delete updatedRow.schedule;
          await onDone(updatedRow);
        } catch (error) {
          handleError(
            "The adjustment could not be updated due to an unexpected error. Please try again later."
          );
        }
      }}
      title='Change Tax Adjustment?'
      description={
        <>
          You are changing the tax adjustment from{" "}
          <strong>{from || "current value"}</strong> to{" "}
          <strong>{to || "new value"}</strong>. This change will impact the
          selected schedule. Do you wish to proceed?
        </>
      }
    />
  );
};

export default ChangeTaggingDialog;
